<template>
  <div class="item-base">
    <user-detail-title
      first-bread="首页管理"
      second-bread="服务项目"
      third-bread="服务项目添加"
      first-url="/user/sign"
      second-url="/user/service_concept"
      title-name="服务项目添加"
    >
    </user-detail-title>
    <user-detail-base>
      <el-form label-position="left" label-width="100px">
        <el-form-item label="大类">
          <el-select v-model="Alist.type" placeholder="请选择">
            <el-option
              v-for="item in Large"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="小类">
          <el-select v-model="Alist.smallType" placeholder="请选择">
            <el-option
              v-for="item in Small"
              :key="item.code"
              :label="item.name"
              :value="item.code">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="主图">
          <el-upload action="/api/photo/uploadFile" :on-success="GetUrlList">
            <el-button slot="trigger" size="small" type="primary">选取图片</el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="描述">
          <el-input  type="textarea"
                     :rows="4"
                     v-model="Alist.description" ></el-input>
        </el-form-item>
        <el-button @click="handleAdd">添加</el-button>
      </el-form>
    </user-detail-base>
  </div>
</template>

<script>
  import UserDetailTitle from "../Common/UserDetailTitle";
  import UserDetailBase from "../Common/UserDetailBase";
  export default {
    name: "ConceptAdd",
    components: {UserDetailBase, UserDetailTitle},
    data(){
      return{
        Large:{},
        Small:{},
        Alist: {
          'type':null,
          'smallType':null,
          'photoUrl':null,
          'description':null,
        },//表示Add添加的数据
      }
    },
    watch:{
      'Alist.type'(code){
        if(code == 1){
          this.GetSmallFirst()
        }
        if(code == 2){
          this.GetSmallSecond()
        }
        if(code == 3){
          this.GetSmallThird()
        }
      }
    },
    created() {
      this.GetLarge()
    },
    methods:{
      GetUrlList(file){
        this.Alist.photoUrl=file.data;
      },
      GetLarge(){
        this.$axios.get('/api/serveItem/getTypeList').then(res=>{
          this.Large=res.data.data;

        })
      },
      GetSmallFirst(){
        this.$axios.get('/api/serveItem/getAudioTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      GetSmallSecond(){
        this.$axios.get('/api/serveItem/getAcousticTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      GetSmallThird(){
        this.$axios.get('/api/serveItem/getMediaServeTypeList').then(res=>{
          this.Small=res.data.data;
        })
      },
      handleAdd(){
        this.$axios.post('/api/serveItem/add',this.Alist).then(res=>{
          if(res.data.success == true){
            this.Alist= {
              'type':null,
              'smallType':null,
              'photoUrl':null,
              'description':null,
            }//表示Add添加的数据,
            this.$message({
              message:'添加成功',
              type:'success'
            })
          }
        })
      }
    },
  }
</script>

<style scoped>

</style>